export default __webpack_public_path__ + "static/media/1.b45179ba.png";